import React from 'react'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Button } from 'semantic-ui-react'
import { useDispatch, useSelector } from 'react-redux'
import { onSaveUser, setSignInState } from '../../../redux/Dashboard/UserReducer'
import { SIGN_IN_STATE, STUDENT, TEACHER } from '../../../constants'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

const ParticipationCard = ({ title, label, link, src, index }) => {
  const dispatch = useDispatch()
  const { user, isLoggedIn } = useSelector(state => state.authentication)
  const history = useHistory()

  const handleLink = (index) => {
    if (link) {
      if (!isLoggedIn) {
        dispatch(onSaveUser({ user: { ...user, persona: TEACHER } }))
        dispatch(setSignInState(SIGN_IN_STATE.SCHOOL_AUTH))
      }
      if (index) {
        history.push(link)
      } else {
        window.location.href = link
      }
    }
  }

  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '285px', textAlign: 'center' }}>
      <Box>
        <img src={src} />
      </Box>
      <Typography variant='body1' sx={{ pl: 2, pr: 2, height: '30px' }}>
        {title}
      </Typography>
      <Box sx={{ p: '0px 8px 16px 8px' }}>
        {label && <Button color='primary' size='large' onClick={() => handleLink(index)} disabled={index === 1 && user?.persona === STUDENT}>{label}</Button>}
      </Box>
    </Card>
  )
}

export default ParticipationCard
